/**
 * Environment-specific configuration
 */
/// <reference types="vite/client" />

const env = {
  development: {
    apiUrl: 'https://api.vezgo.com/v1',
    connectUrl: 'https://connect.vezgo.com/connect',
    clientId: '3vaeo1paa5rpst6q96rp21bo5a', // FIXED: Using correct Client ID
    isProduction: false,
    debug: true
  },
  production: {
    apiUrl: 'https://api.vezgo.com/v1',
    connectUrl: 'https://connect.vezgo.com/connect',
    clientId: '3vaeo1paa5rpst6q96rp21bo5a', // FIXED: Using correct Client ID
    isProduction: true,
    debug: false
  },
  test: {
    apiUrl: 'https://test-api.vezgo.com/v1',
    connectUrl: 'https://test-connect.vezgo.com/connect',
    clientId: '3vaeo1paa5rpst6q96rp21bo5a', // FIXED: Using correct Client ID
    isProduction: false,
    debug: true
  }
};

/**
 * Current environment based on import.meta.env
 */
const currentEnv = import.meta.env?.MODE || 'development';

import { getCurrentOrigin } from '@/constants/environments';

/**
 * Registered Vezgo redirect URIs based on environment
 */
const getRegisteredRedirectURI = () => {
  const origin = getCurrentOrigin();
  
  // Match the redirect URI to one of the registered URIs
  if (origin.includes('altsiq.ai')) {
    return 'https://altsiq.ai/investments/connect/vezgo';
  } else if (origin.includes('superalts-marketplace.lovable.app')) {
    return origin.includes('preview') 
      ? 'https://preview--superalts-marketplace.lovable.app/investments/connect/vezgo'
      : 'https://superalts-marketplace.lovable.app/investments/connect/vezgo';
  }
  
  // Fallback to a registered URI that matches our domain pattern
  return `${origin}/investments/connect/vezgo`;
};

/**
 * Exported configuration
 */
export const config = {
  ...env[currentEnv as keyof typeof env],
  version: '1.0.0',
  appName: 'AltsIQ',
  apiVersion: 'v1'
};

/**
 * Vezgo-specific configuration, centralized in one location
 * This maintains the configuration structure while ensuring no duplication
 */
export const vezgoConfig = {
  apiUrl: config.apiUrl,
  connectUrl: config.connectUrl,
  clientId: config.clientId,
  redirectUri: getRegisteredRedirectURI(),
  registeredRedirectURIs: [
    'https://preview--superalts-marketplace.lovable.app/investments/connect/vezgo',
    'https://superalts-marketplace.lovable.app/investments/connect/vezgo',
    'https://altsiq.ai/investments/connect/vezgo',
    `${getCurrentOrigin()}/investments/connect/vezgo`
  ],
  stateStorageKey: 'vezgo_state',
  returnUrlStorageKey: 'vezgo_return_url',
  providerStorageKey: 'vezgo_provider',
  csrfTokenLength: 32
};
